import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public appName = '';
  public toyotaPrivacyLink = [];
  public lexusPrivacyLink = [];
  constructor() { }

  ngOnInit() {
    this.appName = environment.applicationName;
    this.toyotaPrivacyLink = [{
      privacyLinkName: 'YOUR PRIVACY CHOICES',
      privacyLinkUrl: 'https://www.toyota.com/support/privacy-rights'
    },
    {
      privacyLinkName: 'Legal Terms',
      privacyLinkUrl: 'https://www.toyota.com/support/legal-terms'
    }
    ];
    this.lexusPrivacyLink = [{
      privacyLinkName: 'YOUR PRIVACY CHOICES',
      privacyLinkUrl: 'https://www.lexus.com/privacy'
    },
    {
      privacyLinkName: 'LEGAL',
      privacyLinkUrl: 'https://www.lexus.com/privacy/legal-terms'
    }];
  }
}
